import { Store } from 'library/ts/utilities//Store';
import * as CompareModule from 'library/ts/utilities/compare/';
import { Importer } from 'library/ts/utilities/Importer';
import { Loader } from 'library/ts/utilities/Loader';
import { LogService } from 'library/ts/utilities/logger/LogService';
import * as API from 'library/ts/utilities/modules/API';
import * as ArrayModule from 'library/ts/utilities/modules/Array';
import * as CalcModule from 'library/ts/utilities/modules/Calc';
import * as ConvertModule from 'library/ts/utilities/modules/Convert';
import * as CSSModule from 'library/ts/utilities/modules/CSS';
import * as DateModule from 'library/ts/utilities/modules/Date';
import * as DeepMerge from 'library/ts/utilities/modules/DeepMerge';
import * as Delay from 'library/ts/utilities/modules/Delay';
import * as DOMModule from 'library/ts/utilities/modules/DOM';
import * as EventModule from 'library/ts/utilities/modules/Event';
import * as FullScreenModule from 'library/ts/utilities/modules/FullScreen';
import * as FunctionModule from 'library/ts/utilities/modules/Function';
import * as GAM from 'library/ts/utilities/modules/GAM';
import * as HDCPModule from 'library/ts/utilities/modules/HDCP';
import * as Hotkeys from 'library/ts/utilities/modules/Hotkeys';
import * as ImportModule from 'library/ts/utilities/modules/Import';
import * as NumberModule from 'library/ts/utilities/modules/Number';
import * as ObjectModule from 'library/ts/utilities/modules/Object';
import * as PromiseModule from 'library/ts/utilities/modules/Promise';
import * as StringModule from 'library/ts/utilities/modules/String';
import * as TypeModule from 'library/ts/utilities/modules/Type';
import * as URLModule from 'library/ts/utilities/modules/URL';
import SessionStore from 'library/ts/utilities/SessionStore';
export class Utilities {
    static _name = 'Utilities';
    static _instance = new Utilities();
    name = 'Utilities';
    Array = ArrayModule;
    Calc = CalcModule;
    CSS = CSSModule;
    Compare = CompareModule;
    Convert = ConvertModule;
    Date = DateModule;
    DOM = DOMModule;
    HDCP = HDCPModule;
    Event = EventModule;
    FullScreen = FullScreenModule;
    Function = FunctionModule;
    Import = ImportModule;
    Number = NumberModule;
    Object = ObjectModule;
    Promise = PromiseModule;
    String = StringModule;
    Type = TypeModule;
    URL = URLModule;
    DeepMerge = DeepMerge;
    Delay = Delay;
    Hotkeys = Hotkeys;
    GAM = GAM;
    API = API;
    Loader = Loader;
    Importer;
    Store = Store.getInstance();
    SessionStore = SessionStore.getInstance();
    Log = LogService;
    constructor() {
        if (Utilities._instance) {
            throw new Error(Utilities._name + ' is a Singleton and can only be accessed through ' + Utilities._name + '.getInstance()');
        }
        Utilities._instance = this;
        this.Importer = new Importer();
    }
    static getInstance() {
        return Utilities._instance;
    }
}
